export enum DisplayLanguage {
  English = "English",
  SerbianLatin = "SerbianLatin",
  SerbianCyrillic = "SerbianCyrillic",
}
